import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Inscription, Preloader, RoundPendingIcon, useResponsive } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

interface Props {
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnlockCardConfirmDialog: React.FC<Props> = ({ isLoading, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box direction="column" align="center" data-testid="unlock-card-confirm-dialog">
      <Box align="center" justify="center" width="72px" height="72px">
        <RoundPendingIcon size="48px" color="warning" />
      </Box>
      <Box margin={{ top: 'spacing16', bottom: 'l' }}>
        <Inscription
          size="2xl"
          color="textTitle"
          weight="bold"
          lineHeight="32px"
        >
          {t('Unlock card?')}
        </Inscription>
      </Box>
      <Box
        direction={isMobile ? 'column' : 'row'}
        align="center"
        justify="center"
        width={isMobile ? '100%' : undefined}
        gap="xs"
      >
        <AppButton
          buttonType="secondary"
          width={isMobile ? '100%' : '140px'}
          type="button"
          testId="unlock-card-confirm-dialog_cancel-button"
          onClick={onCancel}
        >
          {t('Cancel')}
        </AppButton>
        <AppButton
          disabled={isLoading}
          type="button"
          color="blue"
          width={isMobile ? '100%' : '140px'}
          testId="unlock-card-confirm-dialog_confirm-button"
          onClick={onConfirm}
        >
          {isLoading ? <Preloader color="white" /> : t('Unlock')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default UnlockCardConfirmDialog;
